import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppResolutionType } from 'app/shared/common/appResolution';
import { ResolutionType } from 'app/shared/model/enums';

@Component({
  selector: 'app-lids-for-business',
  templateUrl: './lids-for-business.component.html',
  styleUrl: './lids-for-business.component.scss'
})
export class LidsForBusinessComponent  implements OnInit{
    businessId!: number | null;
    AppResolutionType = AppResolutionType;
    ResolutionType = ResolutionType;

  constructor(private route: ActivatedRoute) {}
  ngOnInit(): void {
    this.businessId =Number(this.route.parent?.snapshot.paramMap.get('id'));    
  }

}
